export default __webpack_public_path__ + "static/media/paymentBackground.3ff061c0.png";